import { Toast, Spinner } from "../../";
import React, { useRef, useState } from "react";
import { addMultipleUsers } from "Utils/axios";

function AddMultipleUsers({ btnClass = "", SendInvite, onResult, extensions = [".xlsx", ".xls", ".csv"],}) {

  const fileRef = useRef(null);
  const [Loader, setLoader] = useState(false);
  const downloadLink = SendInvite ? "https://cdn.twingstech.com/Corporate_Invite_User_Sample.xlsx" 
                                  : "https://cdn.twingstech.com/Corporate_Create_User_Sample.xlsx";
 
  const checkExtension = (fileName) => {
    return extensions.some((ext) =>
      fileName.toLowerCase().endsWith(ext)
    );
  };

  const handleSelect = (e) => {
    setLoader(true);
    const file = e.target.files[0];
    if (!file) {
      setLoader(false);
      return;
    }

    if (!checkExtension(file.name)) {
      Toast.error(`Only ${extensions.join(",")} files are allowed`);
      fileRef.current.value = "";
      setLoader(false);
      return;
    }

    const MAX_SIZE1 = 500 * 1024; // 500KB in bytes
    const MAX_SIZE2 = 3 * 1024 * 1024; // 3MB in bytes

    const maxSize = SendInvite ? MAX_SIZE1 : MAX_SIZE2

    if (file.size > maxSize) {
      Toast.error("File size must be less than or equal to given limit!");
      fileRef.current.value = "";
      setLoader(false);
      return;
    }
    
    addMultipleUsers( file, (res) => {
      fileRef.current.value = "";
      if (res && onResult) onResult(res);
      setLoader(false);
    },
    SendInvite ? "invite" : "create",
  );

  };

  return (
    <div>
      <input ref={fileRef} type="file" accept={extensions.join(",")} className="hidden" onChange={handleSelect} />
      <div className="flex gap-3">
        <button type="button" onClick={() => fileRef.current.click()} disabled={Loader} className={`btn w-2/4 bg-primary text-white gap-2 ${btnClass}`} >
          {Loader && <Spinner />}
          Upload File
        </button>
        <a href={downloadLink} download className="btn w-2/4 bg-dark text-white gap-2 inline-block text-center">
          Download Sample File
        </a>
      </div>
   </div> 
  );
}

export default AddMultipleUsers;